<template>
	<div id="app" style="min-height:700px;">
		<Loading v-show="xgIsLoad"></Loading>
		<router-view v-wechat-title='$route.meta.title'></router-view>
	</div>
</template>

<script>
	import Loading from './components/common/Loading.vue'
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex";
	
	export default {
		name: 'app',
		computed: mapGetters(['xgIsLoad']),
		methods: {

		},
		unload() {
			this.clearCache();
		},
		components: {
			[Loading.name]: Loading,
		}
	}
</script>

<style>
	div {
		box-sizing: border-box;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		width: 100%;
		height: 100%;

	}
</style>
